import { Navigate, useParams } from "src/router";
import type { RouteObject } from "src/router";
import { lazyNamed } from "src/utils/lazy-named";

const SchemaIdRedirect = lazyNamed(
  () => import("./contract/event-schema/schema-id-redirect"),
  "SchemaIdRedirect",
);

// The legacy Contracts UI was replaced by Event Studio (/events/domains),
// which serves the same `event_plans` rows. These routes only keep old
// /events/contracts URLs (bookmarks, git-sync links, docs) working.
const DomainRedirect = () => {
  const params = useParams();
  const rest = params["*"] ? `/${params["*"]}` : "";
  return <Navigate to={`/events/domains/${params.id}${rest}`} replace />;
};

export const routes: Array<RouteObject> = [
  {
    index: true,
    spacesAccess: "hidden-from-limited-view",
    element: <Navigate to="/events/domains" replace />,
  },
  {
    path: "schemas/:event_schema_id",
    spacesAccess: "hidden-from-limited-view",
    element: <SchemaIdRedirect />,
  },
  {
    path: ":id/*",
    spacesAccess: "hidden-from-limited-view",
    element: <DomainRedirect />,
  },
];
